import { Omit, Typography } from "@material-ui/core";
import { TypographyProps } from "@material-ui/core/Typography";
import { createStyles, makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import * as React from "react";

import { RelodeTheme } from "../";
import { ColorType } from "../utils";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            primary: {
                color: theme.palette.primary.main,
            },
            secondary: {
                color: theme.palette.secondary.main,
            },
            danger: {
                color: theme.relode.colors.danger.main,
            },
            flat: {
                color: theme.relode.colors.flat.main,
            },
            inline: {
                display: "inline-block",
            },
            preserveFormat: {
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
            },
        }),
    { name: "RelodeText" }
);

export interface TextProps extends Omit<TypographyProps, "color"> {
    color?: ColorType;
    isInline?: boolean;
    component?: React.ElementType;
    preserveFormat?: boolean;
    dataCy?: string;
}

export const Text = React.forwardRef((props: TextProps, ref: any) => {
    const { color, className, isInline, preserveFormat, dataCy, ...other } = props;
    const classes = useStyles({});
    const textClassNames = classnames(
        {
            [classes[color!]]: color,
            [classes.inline]: isInline,
            [classes.preserveFormat]: preserveFormat,
        },
        className
    );

    return (
        <Typography
            {...other}
            ref={ref}
            color={color === "inherit" ? "inherit" : undefined}
            className={textClassNames}
            data-cy={dataCy}
        >
            {props.children}
        </Typography>
    );
});
